module.exports = __webpack_public_path__ + "img/clothes.6ea2765a.png";